import React, { useEffect } from 'react';
import { Container, Accordion } from "react-bootstrap";
import { FaSadTear } from 'react-icons/fa';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";
import useFetch from '../useFetch';
import { Spinner } from 'react-bootstrap';

gsap.registerPlugin(ScrollTrigger);

const Services = () => {

    //load google sheets data for Services
    const sheetRange = "Services"; //for services

    const { data, loading, error } = useFetch(sheetRange);

    const servicesData = data ? data.values.slice(1).map(row => ({
        service: row[0],
        description: row[1],
    })) : [];

        //animate on scroll
    useEffect(() => {
        // Register ScrollTrigger with GSAP
        gsap.registerPlugin(ScrollTrigger);
    
        if(window.innerWidth > 768){
            // Target each accordion item for animation || after loading
            if (!loading) {
                gsap.utils.toArray(".accordion-item").forEach((itemA, index) => {
                    gsap.fromTo(itemA, 
                        { y: 150, opacity: 0 }, // from state
                        {
                        opacity: 1,
                        duration: 1, // Animation duration
                        y: -50, // Move to original position
                        ease: 'none', // Animation easing
                        scrollTrigger: {
                            trigger: itemA,
                            start: 'top 90%', // Start animation when top of item hits 80% of viewport
                            toggleActions: 'play none none reverse', // Play animation forwards and reverse on scroll up    
                            //scrub: true, // Smooth animation
                        },
                        }
                    );
                });
            }
        }
    }, [loading]);

    return (
        <div>
            <Container fluid id="secServices">
                { loading ? (
                    <div className='d-flex align-items-center justify-content-center secLoad'>
                        <Spinner animation="grow" role="status" className='loadingSpinner'>
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    </div>
                ) : error ? ( 
                    <div className='d-flex flex-column align-items-center justify-content-center secLoad'>
                        <FaSadTear size={60} />
                        <h2>Error loading data: {error.message}</h2>
                    </div>  
                ) : (
                    <Accordion id="accordionServices" defaultActiveKey="4">
                        {servicesData.map((item, index) => (
                            <Accordion.Item eventKey={index.toString()} key={index}>
                                <Accordion.Header>
                                    {item.service}
                                </Accordion.Header>
                                <Accordion.Body>
                                    {item.description}
                                </Accordion.Body>
                            </Accordion.Item>
                        ))}
                    </Accordion>
                )}
            </Container>
        </div>
    )
}

export default Services;